import CustomerPortalDispatcher from '../dispatcher/CustomerPortalDispatcher';
import CustomerPortalStore from '../stores/CustomerPortalStore';

import authenticationService from '../authenticationService';

import Swal from 'sweetalert2';
import _ from 'lodash';
import * as API from './API_LOCATIONS';

import SUCCESS_ICON from './success_icon.svg';
import ERROR_ICON from './error_icon.svg';
import WARNING_ICON from './warning_icon.svg';

const icons = {
    success: SUCCESS_ICON,
    error: ERROR_ICON,
    warning: WARNING_ICON
}
var toastOption = {
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    customClass: {
        container: 'toast-alert'
    },
    onBeforeOpen: (toast) => {
        window.translate();
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
};

const alertType = {
    success: 'success',
    error: 'danger',
    info: 'primary'
};

function displayToast(type, msg) {
    toastOption.customClass.popup = ('alert alert-' + alertType[type]);
    let Toast = Swal.mixin(toastOption);
    Toast.fire({
        icon: type,
        title: `<span data-translation="general.error.${msg}">${msg}</span>`,
    });
}

const defaultTitle = 'ERROR';
const defaultMsg = "Something unexpected has occurred, please try again later.";
const defaultOptions = {
    extraOptions: {},
    autoRedirect: true,
    afterAction: undefined
}
function displayGeneralMessage(msg = defaultMsg, title = defaultTitle, type = 'error', allowDismiss = true, extraOptions = defaultOptions) {
    if (msg.message && typeof msg.message === 'string') msg = msg.message;
    let content = `<div class='swal2-custom-container'>`;
    if (icons[type]) {
        content += `<div class='swal2-header-section d-flex align-items-center'>
                        <img class='img-fluid swal2-img' src="${icons[type]}"}/>
                        <div class='swal-2-title'><b>${title}</b></div>
                    </div>`
    } else {
        content += `<div class='text-center'>
                        <p class='swal-2-title'><b>${title}</b></p>
                    </div>`
    }
    content += `<span data-translation="general.error.${msg}">${msg}</span>
             </div>`;
    let options = {
        html: (content),
        allowOutsideClick: allowDismiss,
        allowEscapeKey: allowDismiss,
        allowEnterKey: allowDismiss,
        showCloseButton: true,
        showConfirmButton: allowDismiss,
        confirmButtonColor: '#3B555B',
        onBeforeOpen: () => {
            window.translate();
        }
    };
    if (options.extraOptions) options = { ...options, ...extraOptions.extraOptions };
    Swal.fire(options).then(function (result) {
        if (extraOptions.autoRedirect) window.location.href = window.location.origin;
        if (extraOptions.afterAction && typeof options.afterAction == 'function') options.afterAction()
        return null;
    });
}
class CustomerPortalAction {
    displayGeneralMessage(msg = defaultMsg, title = defaultTitle, type = 'error', allowDismiss = true, options = defaultOptions) {
        displayGeneralMessage(msg, title, type, allowDismiss, options);
    }
    submitArticle(data) {
        CustomerPortalDispatcher.dispatch({
            actionType: 'SUBMIT_ARTICLE',
            value: data
        });

        CustomerPortalDispatcher.dispatch({
            actionType: 'APPROVE_ARTICLE',
            value: data
        });
    }
    removeArticle(key) {
        CustomerPortalDispatcher.dispatch({
            actionType: 'REMOVE_ARTICLE',
            value: key
        });
    }
    // ------------------------------- General tab actions -------------------------------
    // data handling functions
    convertObjectToQueryString(obj) {
        return Object.keys(obj).map(function (k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k])
        }).join('&');
    }
    sendErrorLog(page,error,info){
      let user = CustomerPortalStore.getCurrentUserName();
      let msg = `user: "${user}", page: "${window.origin + page}", errorType: "${error.name}", error: "${error.message}"`;
      let url = API.HOST + '/api/log';
      if(!localStorage.currentUser) return false
      fetch(url, {
          method: 'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(msg),
      }).then((response) => {
          if (response.status == 500)
              throw new Error(response.status)
      }).catch((error) => {
          console.error(`fetch error: ${error}`);
      });
    }
    // Get General information, such as topic/users requirements
    fetchHeaderInfo(isLoggedIn) {
        fetch(API.HOST + API.FETCH_HEADER_INFO, {}).then((response) => {
            if (response.status !== 200) {
                throw new Error(response.status)
            }
            return response.json()
        }).then((data) => {
            if (data.redirectUrl) {
                window.location.href = data.redirectUrl;
            }
            let features = [];
            if (isLoggedIn) {
                const currentUser = JSON.parse(localStorage.getItem("currentUser") || sessionStorage.getItem("currentUser"));
                data.userName = currentUser.name;
                features = currentUser.features;
            }
            CustomerPortalDispatcher.dispatch({
                actionType: 'SET_HEADER',
                header: {
                    headerInfo: data,
                    login: isLoggedIn,
                    features: features
                },
                language: data.language
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    switchLanguage(language){
      CustomerPortalDispatcher.dispatch({
          actionType: 'SET_LANGUAGE',
          language: language
      });
    }
    registerNewAccount(input,displayModal) {
        let url = API.HOST + API.POST_NEW_ACCOUNT;
        fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(input),
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (!data.error) {
                displayGeneralMessage('', 'You are now registered!', 'success', true)
                localStorage.setItem('currentUser', JSON.stringify(data));
                sessionStorage.setItem('currentUser', JSON.stringify(data));
                CustomerPortalDispatcher.dispatch({
                    actionType: 'SET_USER_LOGIN',
                    user: data,
                    features: data.features,
                    secretKey: data.token,
                    userName: data.name
                });
            } else if (data.error == 'register-needs-approval') {
                displayModal(false);
                displayGeneralMessage("We will verify and approve your access shortly.", "Thank you for your registration", "success", true, { autoRedirect: false });
            } else {
                if (typeof data.error === 'string') data.error = { error: data.error }
                CustomerPortalDispatcher.dispatch({
                    actionType: 'SET_ERROR',
                    errors: data.error
                });
            }
        }).catch((error) => {
            CustomerPortalDispatcher.dispatch({
                actionType: 'SET_ERROR',
                errors: {error: 'Unexpected error, Please try again later'}
            });
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    };
    async RequestNewAccount(input) {
        return new Promise((resolve, reject) => {
            let url = API.HOST + API.POST_REQUEST_ACCOUNT;
            fetch(url, {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(input),
            }).then((response) => {
                if (response.status == 500)
                    throw new Error(response.status)
                return response.json()
            }).then((data) => {
                if (!data.error) {
                    displayGeneralMessage("We will contact you shortly", "Thank you for your request", "success", true, { autoRedirect: false });
                }
                resolve(data);
            }).catch((error) => {
                console.error(`fetch error: ${error}`);
            });
        })
    };
    async postResetPasswordForm(username, email) {
        return new Promise((resolve, reject) => {
            let params = { username: username, email: email };
            let url = API.HOST + API.POST_RESET_PASSWORD_FORM;
            fetch(url, {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(params),
            }).then((response) => {
                if (response.status !== 200)
                    throw new Error(response.status);
                return response.json();
            }).then((data) => {
                if (!data.message) {
                    resolve(true);
                } else {
                    CustomerPortalDispatcher.dispatch({
                        actionType: 'SET_ERROR',
                        errors: data.message
                    });
                    resolve(false);
                }
            }).catch((error) => {
                displayGeneralMessage();
                console.error(`fetch error: ${error}`);
            });
        })
    };
    postResetPassword(input) {
        let url = API.HOST + API.POST_RESET_PASSWORD + '?token=' + input.token;
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            method: 'POST',
            body: JSON.stringify(input),
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (data.success) {
                Swal.fire({
                    title: "",
                    text: "Password updated",
                    imageUrl: icons['success'],
                    imageWidth: 76,
                    imageHeight: 76,
                }).then(function () {
                    if(localStorage.currentUser) localStorage.removeItem('currentUser');
                    if(sessionStorage.currentUser) sessionStorage.removeItem('currentUser');
                    CustomerPortalDispatcher.dispatch({
                        actionType: 'USER_LOG_OUT'
                    });
                    window.location.href = window.location.origin;
                });
            } else {
                CustomerPortalDispatcher.dispatch({
                    actionType: 'SET_ERROR',
                    errors: {message:data.error}
                });
            }
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    };
    sendContactWithoutLogin(msg,displayModal,response='Your message has been sent to our team') {
        let url = API.HOST + API.SEND_CONTACT_WITHOUT_LOGIN;
        fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(msg),
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            displayModal(false);
            displayGeneralMessage(response, 'Sent!', 'success', true, { autoRedirect: false });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    setLogin(user) {
        CustomerPortalDispatcher.dispatch({
            actionType: 'SET_USER_LOGIN',
            user: user,
            features: user.features,
            secretKey: user.token,
            userName: user.name,
            language: user.language
        });
    }
    async logout() {
        return new Promise((resolve, reject) => {
            CustomerPortalDispatcher.dispatch({
                actionType: 'USER_LOG_OUT',
            });
            resolve(true);
        });
    }
    async fetchPopUpMessage() {
        return new Promise((resolve, reject) => {
            fetch(API.HOST + API.FETCH_POPUP_API, {
                headers: {
                    'Authorization': authenticationService()
                }
            }).then((response) => {
                if (response.status !== 200)
                    throw new Error(response.status)
                return response.json()
            }).then((data) => {
                CustomerPortalDispatcher.dispatch({
                    actionType: 'SET_BROADCAST_STATUS',
                    status: false
                });
                resolve(data);
            }).catch((error) => {
                console.error(`fetch error: ${error}`);
            });
        })
    };
    postPopUpMessage() {
        let url = API.HOST + API.PUT_POPUP_DISMISS;
        fetch(url, {
            method: 'put',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            },
            body: JSON.stringify({}),
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
        }).catch((error) => {
            console.error(`fetch error: ${error}`);
        });
    };
    enableBroadCastCheck(){
      CustomerPortalDispatcher.dispatch({
          actionType: 'SET_BROADCAST_STATUS',
          status: true
      });
    }
    async getBoardcastDate() {
        return new Promise((resolve, reject) => {
            let url = API.HOST + API.GET_BROADCAST_DATE;
            fetch(url, {
                method: 'get',
                headers: {
                    'Authorization': authenticationService()
                },
            }).then((response) => {
                if (response.status !== 200)
                    throw new Error(response.status)
                return response.json()
            }).then((data) => {
                resolve(data);
            }).catch((error) => {
                console.error(`fetch error: ${error}`);
            });
        })
    };
    postBroadcastDate() {
        let url = API.HOST + API.SET_BROADCAST_DATE;
        fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            },
            body: JSON.stringify({}),
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            return true;
        }).catch((error) => {
            console.error(`fetch error: ${error}`);
        });
    };
    async fetchCustomerList(query) {
        return new Promise((resolve, reject) => {
          let url = API.HOST + API.FETCH_SALESPERSON_LIST + '?';
          url += this.convertObjectToQueryString({query:query});
          fetch(url, {
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': authenticationService()
              }
          }).then((response) => {
              if (response.status == 500)
                  throw new Error(response.status)
              return response.json()
          }).then((data) => {
              if (!data.error) {
                  resolve(data);
              } else {
                  displayGeneralMessage(data.error, undefined, 'error', false, { autoRedirect: false });
              }
          }).catch((error) => {
              displayGeneralMessage();
              console.error(`fetch error: ${error}`);
          });
        });
    };
    async fetchSalespersonNumber() {
        return new Promise((resolve, reject) => {
            let url = API.HOST + API.SALESPERSON_AR_API;
            fetch(url, {
                method: 'get',
                headers: {
                    'Authorization': authenticationService()
                },
            }).then((response) => {
                if (response.status !== 200)
                    throw new Error(response.status)
                return response.json()
            }).then((data) => {
                debugger
                resolve(data);
            }).catch((error) => {
                console.error(`fetch error: ${error}`);
            });
        })
    };
    async setClientNumber(person) {
        return new Promise((resolve, reject) => {
            let url = API.HOST + API.SALESPERSON_AR_API + '?';
            url += this.convertObjectToQueryString({arcustomer:person.arCustomerNo});
            fetch(url, {
                method: 'PUT',
                headers: {
                    'Authorization': authenticationService()
                },
            }).then((response) => {
                if (response.status == 500)
                    throw new Error(response.status)
                return response.json()
            }).then((data) => {
                if (data.success) {
                  CustomerPortalDispatcher.dispatch({
                    actionType: 'SET_SALESPERSON_CUSTOMER',
                    data: person
                  });
                  resolve(undefined)
                } else { // error
                  displayGeneralMessage(data.message, undefined, 'error', true, { autoRedirect: false });
                  resolve(true)
                }
            }).catch((error) => {
                console.error(`fetch error: ${error}`);
            });
        })
    };
    fetchActivityCustomerActivity(retry = true) {
        fetch(API.HOST + API.CUSTOMER_ACTIVITY_API, {
            headers: {
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (data.error)
                throw new Error(data)
            if(data.customerActivity){
              data.customerActivity.lastStatementDate = (data.customerActivity.lastStatementDate == 0) ? (undefined) : (data.customerActivity.lastStatementDate);
              if(data.customerActivity){
                let year = new Date().getFullYear();
                let graphData = [{
                  label:year-2, value:(data.customerActivity.lastLastYearTotalInvoices||'0').replace(/[^\d.]/g, '')
                },{
                  label:year-1, value:(data.customerActivity.lastYearTotalInvoices||'0').replace(/[^\d.]/g, '')
                },{
                  label:year, value:(data.customerActivity.yearToDateTotalInvoices||'0').replace(/[^\d.]/g, '')
                }]
                data.customerActivity.graphData = Object.keys(graphData).map(e => graphData[e]);
              }
              document.getElementById('currencysymbol').value = data.customerActivity.currencySymbol;
            }
            CustomerPortalDispatcher.dispatch({
                actionType: 'SET_ACTIVITY_CUSTOMER_ACTIVITY',
                data: data
            });
        }).catch((error) => {
            if(retry){
              this.fetchActivityCustomerActivity(false)
            } else {
              displayGeneralMessage();
              console.error(`fetch error: ${error}`);
            }
        });
    }
    fetchRecentInvoices(){
        let params = { type: 'invoice', show: 'all', page: 1, perpage: 3, sortBy: 'docDate', descending: 1 };
        let url = API.HOST + API.FETCH_TRANSACTIONS_API + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (data.error) {
                throw new Error(data.error)
            }
            CustomerPortalDispatcher.dispatch({
                actionType: 'FETCH_RECENT_INVOICES',
                data: data.transactions,
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    fetchRecentReceipt(){
        let params = { type: 'receipt', show: 'all', page: 1, perpage: 3, sortBy: 'docDate', descending: 1 };
        let url = API.HOST + API.FETCH_TRANSACTIONS_API + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (data.error) {
                throw new Error(data.error)
            }
            CustomerPortalDispatcher.dispatch({
                actionType: 'FETCH_RECENT_RECEIPTS',
                data: data.transactions,
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    fetchActivityCustom(){
        let settings = CustomerPortalStore.getAccountActivitySetting() || {};
        let customerNumber = CustomerPortalStore.getCustomerNumber();
      let params = {
          template: settings.template,
          customerNumber: customerNumber,
      };
      let url = API.HOST + API.FETCH_DOC_DETAILS_CUSTOM_API + '?';
      url += this.convertObjectToQueryString(params);
      fetch(url, {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': authenticationService()
          }
      }).then((response) => {
          if (response.status == 500)
              throw new Error(response.status)
          return response.json()
      }).then((data) => {
          if (!data.error) {
              CustomerPortalDispatcher.dispatch({
                actionType: 'SET_ACTIVITY_CUSTOMER_ACTIVITY',
                data: data
              });
          } else {
              displayGeneralMessage(data.error, undefined, 'error', false, { autoRedirect: false });
          }
      }).catch((error) => {
          displayGeneralMessage();
          console.error(`fetch error: ${error}`);
      });
    }
    fetchTransactions(type = 'all', show = 'all', page = 1, perpage = 10) {
        let params = {
            type: type,
            show: show,
            page: page,
            perpage: perpage,
            sortBy: 'docDate',
            descending: 1,
        };
        let url = API.HOST + API.FETCH_TRANSACTIONS_API + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (data.error) {
                throw new Error(data.error)
            }
            CustomerPortalDispatcher.dispatch({
                actionType: 'FETCH_TRANSACTIONS',
                transactionData: data,
                page: page,
                show: show,
                type: type,
                perpage: perpage
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    fetchTransactionsCM(type = 'all', show = 'all', page = 1, perpage = 10) {
        setTimeout(function(){
          let data = {
            data: [
              {
              	className:'d-flex',
              	elements: [
              		{
              			className:'',
              			dataType: 'table-selector',
              			title: 'Transaction Type',
              			dataName:'type',
              			data:[
              				{text:'All',value:'all'},
              				{text:'Invoice',value:'invoice'},
              				{text:'Unapplied Cash',value:'unappliedcash'},
              				{text:'Debit Note',value:'debitnote'},
              				{text:'Credit Note',value:'creditnote'},
              				{text:'Interest',value:'interest'},
              			]
              		},
              		{
              			className:'flex-grow-1 pl-5',
              			dataType: 'table-selector',
              			title: 'Show',
              			dataName:'show',
              			data:[
              				{text:'All',value:'all'},
              				{text:'Open Only',value:'open'},
              			]
              		},
              		{
              			className:'text-md-right',
              			dataType: 'table-selector',
              			title: 'Transactions per page',
              			dataName:'perpage',
              			data:[
              				{text:'10',value:'10'},
              				{text:'25',value:'25'},
              				{text:'50',value:'50'},
              			]
              		}
              	]
              },
              {
              	className:'div-white-background',
              	dataType: 'table',
              	columns:['TYPE','DOCUMENT NO.','DOC.DATE','DUE DATE','PO#','ORIG.AMT','APPLIED AMT','BALANCE'],
              	width:[15,25,12,12,6,10,10,10],
              	customClass:['doc-type-data','doc-number','','','','text-md-right','text-md-right','text-md-right'],
              	fields:['docType','docLink','docDate','dueDate','poNo','originalAmt','appliedAmt','currentAmt'],
              	data:[
              		{"entryNumber":"2","docDate":"07/30/2020","batchNumber":"61","currencyCode":"USD","dueDate":"08/05/2020","salesPerson":"BB","orderNumber":"","currentAmt":"$ 406.27","appliedAmt":"$ 812.54","docType":"invoice","invoiceType":"2","customerNo":"1200","fullyPaid":false,"documentDescription":"Equipment Maintains","docNo":"IN00000000000000000006","source":"AR","receiptNumber":"","originalAmt":"$ 406.27","poNo":"","transactionType":"summary","details":[]},
              		{"entryNumber":"1","docDate":"07/01/2020","batchNumber":"65","currencyCode":"USD","dueDate":"07/15/2020","salesPerson":"BB","orderNumber":"","currentAmt":"$ 0.00","appliedAmt":"$ 2,338.04","docType":"invoice","invoiceType":"2","customerNo":"1200","fullyPaid":false,"documentDescription":"","docNo":"IN0000000000061","source":"OE","receiptNumber":"","originalAmt":"$ 2,338.04","poNo":"","transactionType":"summary","details":[]},
              		{"entryNumber":"3","docDate":"06/30/2020","batchNumber":"25","currencyCode":"USD","dueDate":"07/05/2020","salesPerson":"BB","orderNumber":"","currentAmt":"$ 1,623.75","appliedAmt":"$ 0.00","docType":"invoice","invoiceType":"1","customerNo":"1200","fullyPaid":false,"documentDescription":"Project and Job Costing Billings","docNo":"IN00000000000000000003","source":"PM","receiptNumber":"","originalAmt":"$ 1,623.75","poNo":"","transactionType":"item","details":[]},
              		{"entryNumber":"4","docDate":"06/30/2020","batchNumber":"25","currencyCode":"USD","dueDate":"06/30/2020","salesPerson":"BB","orderNumber":"","currentAmt":"$ 43.30","appliedAmt":"$ 0.00","docType":"creditnote","invoiceType":"1","customerNo":"1200","fullyPaid":false,"documentDescription":"Project and Job Costing Billings","docNo":"CR00000000000000000002","source":"PM","receiptNumber":"","originalAmt":"$ 43.30","poNo":"","transactionType":"item","details":[]},
              		{"entryNumber":"1","docDate":"06/24/2020","batchNumber":"67","currencyCode":"USD","dueDate":"07/05/2020","salesPerson":"BB","orderNumber":"","currentAmt":"$ 0.00","appliedAmt":"$ 117.10","docType":"invoice","invoiceType":"1","customerNo":"1200","fullyPaid":false,"documentDescription":"","docNo":"IN00000000000000000013","source":"AR","receiptNumber":"","originalAmt":"$ 117.10","poNo":"","transactionType":"item","details":[]},
              		{"entryNumber":"1","docDate":"06/24/2020","batchNumber":"66","currencyCode":"USD","dueDate":"07/05/2020","salesPerson":"BB","orderNumber":"","currentAmt":"$ 137.60","appliedAmt":"$ 264.37","docType":"invoice","invoiceType":"1","customerNo":"1200","fullyPaid":false,"documentDescription":"","docNo":"IN00000000000000000012","source":"AR","receiptNumber":"","originalAmt":"$ 126.77","poNo":"","transactionType":"item","details":[]},
              		{"entryNumber":"1","docDate":"06/15/2020","batchNumber":"25","currencyCode":"USD","dueDate":"06/15/2020","salesPerson":"","orderNumber":"","currentAmt":"$ 50.00","appliedAmt":"$ 0.00","docType":"prepayment","invoiceType":"2","customerNo":"1200","fullyPaid":false,"documentDescription":"Received in advance from Ron","docNo":"PP00000000000000000001","source":"AR","receiptNumber":"2501","originalAmt":"$ 50.00","poNo":"","transactionType":"summary","details":[]},
              		{"entryNumber":"1","docDate":"06/01/2020","batchNumber":"24","currencyCode":"USD","dueDate":"06/01/2020","salesPerson":"","orderNumber":"","currentAmt":"$ 621.99","appliedAmt":"$ 1,623.48","docType":"receipt","invoiceType":"2","customerNo":"1200","fullyPaid":false,"documentDescription":"","docNo":"PY00000000000000000049","source":"AR","receiptNumber":"000000024-00001","originalAmt":"$ 2,245.47","poNo":"","transactionType":"summary","details":[]},
              		{"entryNumber":"1","docDate":"06/01/2020","batchNumber":"18","currencyCode":"USD","dueDate":"06/15/2020","salesPerson":"BB","orderNumber":"","currentAmt":"$ 0.00","appliedAmt":"$ 403.77","docType":"invoice","invoiceType":"1","customerNo":"1200","fullyPaid":false,"documentDescription":"Desc","docNo":"IN1832","source":"AR","receiptNumber":"","originalAmt":"$ 403.77","poNo":"","transactionType":"item","details":[]},
              		{"entryNumber":"3","docDate":"05/31/2020","batchNumber":"53","currencyCode":"USD","dueDate":"05/31/2020","salesPerson":"","orderNumber":"","currentAmt":"$ 0.00","appliedAmt":"$ 97.43","docType":"receipt","invoiceType":"2","customerNo":"1200","fullyPaid":true,"documentDescription":"","docNo":"PY00000000000000000071","source":"AR","receiptNumber":"WT01247741","originalAmt":"$ 97.43","poNo":"","transactionType":"summary","details":[]}
              	],
              },
              {
              	className:'text-center d-flex justify-content-around d-md-block',
              	elements:[
              		{
              			className:'',
              			dataType:'previous-btn',
              		},
              		{
              			className:'',
              			dataType:'next-btn',
              		}
              	]
              }
            ]
          }
          CustomerPortalDispatcher.dispatch({
              actionType: 'FETCH_TRANSACTIONS_CM',
              data: data,
          });
        },500);
    }
    fetchTransactionSetting() {
        fetch(API.HOST + API.FETCH_TRANSACTION_SETTINGS_API, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            let arr = [];
            _.forEach(data.transactiontypes, (item, key) => { arr.push(item.type) })
            let transactionSettings = {
                type: data.transactiontype,
                page: 1,
                perpage: data.perpage,
                transactiontypes: arr
            }
            CustomerPortalDispatcher.dispatch({
                actionType: 'FETCH_TRANSACTION_SETTING',
                transactionSettings: transactionSettings
            });
        }).catch((error) => {
            // displayGeneralMessage(error);
            console.error(`fetch error: ${error}`);
        });
    }
    async fetchTransactionUpdateDate() {
        return new Promise((resolve, reject) => {
            let url = API.HOST + API.FETCH_TRANSACTION_UPDATE_DATE;
            fetch(url, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': authenticationService()
                }
            }).then((response) => {
                if (response.status !== 200)
                    throw new Error(response.status)
                return response.json()
            }).then((data) => {
                let date = CustomerPortalStore.getTransactionsUpdateDate();
                if (date !== data) {
                    CustomerPortalDispatcher.dispatch({
                        actionType: 'FETCH_TRANSACTION_UPDATE_DATE',
                        data: data
                    });
                    resolve(true);
                } else {
                    resolve(false);
                }

            }).catch((error) => {
                console.error(`fetch error: ${error}`);
            });
        })
    };
    fetchOrdersCM(viewby = 'order', type = 'all', show = 'all', page = 1, perpage = 10) {
        setTimeout(function(){
          let data = {
            data: [
              {
              	className:'d-flex',
              	elements: [
              		{
              			className:'flex-grow-1',
              			dataType: 'table-selector',
              			title: 'View By',
              			dataName:'viewby',
              			data:[
              				{text:'Orders',value:'order'},
              				{text:'Items',value:'item'}
              			]
              		},
              		{
              			className:'text-md-right',
              			dataType: 'table-selector',
              			title: 'Items per page',
              			dataName:'perpage',
              			data:[
              				{text:'10',value:'10'},
              				{text:'25',value:'25'},
              				{text:'50',value:'50'},
              			]
              		}
              	]
              },
              {
              	className:'div-white-background p-0 mt-2',
              	dataType: 'list-table',
              	columns:['ITEM NO.','DESCRIPTION','DOCUMENT NO.','DOC.DATE','QTY ORDERED','QTY SHIPPED','QTY B/ORDER','UNIT PRICE'],
              	width:[10,25,15,10,11,11,11,10],
              	customClass:['','','doc-number','','text-md-right','text-md-right','text-md-right','text-md-right'],
                fields:['itemNo','description','orderNo','orderDate','qty','qtyShipped','qtyBackorder','unitPrice'],
              	data:[
                  { "itemNo"       : "A1-103/0",
                    "lineNo"       : "1",
                    "description"  : "Fluorescent Desk Lamp",
                    "orderNo"      : "ORD000000000138",
                    "orderDate"    : "08/07/2020",
                    "qty"          : "1",
                    "qtyShipped"   : "0",
                    "qtyBackorder" : "1",
                    "unitPrice"    : "$ 59.99" },
                  { "itemNo"       : "A1-103/0",
                    "lineNo"       : "2",
                    "description"  : "Fluorescent Desk Lamp",
                    "orderNo"      : "ORD000000000137",
                    "orderDate"    : "08/07/2020",
                    "qty"          : "1",
                    "qtyShipped"   : "0",
                    "qtyBackorder" : "1",
                    "unitPrice"    : "$ 59.99" },
                  { "itemNo"       : "A1-103/0",
                    "lineNo"       : "3",
                    "description"  : "Fluorescent Desk Lamp",
                    "orderNo"      : "ORD000000000136",
                    "orderDate"    : "08/06/2020",
                    "qty"          : "1",
                    "qtyShipped"   : "0",
                    "qtyBackorder" : "1",
                    "unitPrice"    : "$ 59.99" },
                  { "itemNo"       : "F1-470/T",
                    "lineNo"       : "4",
                    "description"  : "Filing Cabinet - 4 Drawers - Hunts-2500",
                    "orderNo"      : "ORD000000000135",
                    "orderDate"    : "08/04/2020",
                    "qty"          : "1",
                    "qtyShipped"   : "0",
                    "qtyBackorder" : "1",
                    "unitPrice"    : "$ 421.96" },
                  { "itemNo"       : "A1-310/0",
                    "lineNo"       : "5",
                    "description"  : "Halogen Desk Light",
                    "orderNo"      : "ORD000000000134",
                    "orderDate"    : "08/04/2020",
                    "qty"          : "1",
                    "qtyShipped"   : "0",
                    "qtyBackorder" : "1",
                    "unitPrice"    : "$ 50.35" },
                  { "itemNo"       : "A1-103/0",
                    "lineNo"       : "6",
                    "description"  : "Fluorescent Desk Lamp",
                    "orderNo"      : "ORD000000000133",
                    "orderDate"    : "08/04/2020",
                    "qty"          : "1",
                    "qtyShipped"   : "0",
                    "qtyBackorder" : "1",
                    "unitPrice"    : "$ 59.99" },
                  { "itemNo"       : "A1-103/0",
                    "lineNo"       : "7",
                    "description"  : "Fluorescent Desk Lamp",
                    "orderNo"      : "ORD000000000132",
                    "orderDate"    : "07/31/2020",
                    "qty"          : "1",
                    "qtyShipped"   : "0",
                    "qtyBackorder" : "1",
                    "unitPrice"    : "$ 59.99" },
                  { "itemNo"       : "A1-103/0",
                    "lineNo"       : "8",
                    "description"  : "Fluorescent Desk Lamp",
                    "orderNo"      : "ORD000000000131",
                    "orderDate"    : "07/30/2020",
                    "qty"          : "1",
                    "qtyShipped"   : "0",
                    "qtyBackorder" : "1",
                    "unitPrice"    : "$ 59.99" },
                  { "itemNo"       : "A1-103/0",
                    "lineNo"       : "9",
                    "description"  : "Fluorescent Desk Lamp",
                    "orderNo"      : "ORD000000000130",
                    "orderDate"    : "07/30/2020",
                    "qty"          : "1",
                    "qtyShipped"   : "0",
                    "qtyBackorder" : "1",
                    "unitPrice"    : "$ 59.99" },
                  { "itemNo"       : "A1-103/0",
                    "lineNo"       : "10",
                    "description"  : "Fluorescent Desk Lamp",
                    "orderNo"      : "ORD000000000129",
                    "orderDate"    : "07/30/2020",
                    "qty"          : "1",
                    "qtyShipped"   : "0",
                    "qtyBackorder" : "1",
                    "unitPrice"    : "$ 59.99" }
                ],
              }
            ]
          }
          CustomerPortalDispatcher.dispatch({
              actionType: 'FETCH_ORDERS_CM',
              data: data,
          });
        },500);
    }
    fetchOrder(viewby = 'order', doctype = 'all', show = 'all', page = 1, perpage = 10) {
        // eslint-disable-next-line
        (viewby == 'order') ? (this.fetchOrderByOrder(doctype, show, page, perpage)) : (this.fetchOrderByItem(doctype, show, page, perpage));
    }
    fetchOrderByOrder(doctype = 'all', show = 'open', page = 1, perpage = 10) {
        let params = {
            show: show,
            currentPage: page,
            doctype: doctype,
            ordersPerPage: perpage,
        };
        if (!show) {
            delete params.show;
        }
        let url = API.HOST + API.FETCH_ORDERS_LIST_API + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (data.error) {
                throw new Error(data.error)
            }
            CustomerPortalDispatcher.dispatch({
                actionType: 'FETCH_ORDERS',
                orderData: data,
                page: page,
                doctype: doctype,
                perpage: perpage,
                viewby: 'order'
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    fetchOrderByItem(doctype = 'all', show = 'open', page = 1, perpage = 10) {
        let params = {
            show: show,
            page: page,
            docfilter: doctype,
            results: perpage,
        };
        if (!show) {
            delete params.show;
        }
        let url = API.HOST + API.FETCH_ORDERS_ITEM_API + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (data.error) {
                throw new Error(data.error)
            }
            CustomerPortalDispatcher.dispatch({
                actionType: 'FETCH_ORDERS',
                orderData: data,
                page: page,
                doctype: doctype,
                perpage: perpage,
                viewby: 'item'
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    };
    fetchOrdersSetting() {
        fetch(API.HOST + API.FETCH_ORDERS_SETTINGS_API, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            let arr = [];
            _.forEach(data.types, (item, key) => { arr.push(item.type) })
            data.orderType = arr;
            CustomerPortalDispatcher.dispatch({
                actionType: 'FETCH_ORDER_SETTING',
                orderSettings: data
            });
        }).catch((error) => {
            // displayGeneralMessage(error);
            console.error(`fetch error: ${error}`);
        });
    }
    async fetchOrderDetails(docNo){
      return new Promise((resolve, reject) => {
        let params = { docNo: docNo };
        let url = API.HOST + API.FETCH_ORDERS_DETAILS + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': authenticationService()
          }
        }).then((response) => {
          if (response.status == 500)
          throw new Error(response.status)
          return response.json()
        }).then((data) => {
          if (data.error) {
            throw new Error(data.error)
          }
          CustomerPortalDispatcher.dispatch({
            actionType: 'FETCH_PAY_ACCOUNT_DETAILS',
            data: data,
            docNo: docNo
          });
          resolve(data);
        }).catch((error) => {
          displayGeneralMessage();
          console.error(`fetch error: ${error}`);
        });
      });
    }
    async fetchOrdersUpdateDate() {
        return new Promise((resolve, reject) => {
            let url = API.HOST + API.FETCH_ORDERS_UPDATE_DATE;
            fetch(url, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': authenticationService()
                }
            }).then((response) => {
                if (response.status !== 200)
                    throw new Error(response.status)
                return response.json()
            }).then((data) => {
                let date = CustomerPortalStore.getOrderUpdateDate();
                if (date !== data) {
                    CustomerPortalDispatcher.dispatch({
                        actionType: 'FETCH_ORDER_UPDATE_DATE',
                        data: data
                    });
                    resolve(true);
                } else {
                    resolve(false);
                }

            }).catch((error) => {
                console.error(`fetch error: ${error}`);
            });
        })
    };
    fetchDocumentDrillDown(orderNo,docType,docStatus) {
        let url = API.HOST + API.FETCH_DOCUMENT_DRILLDOWN + `?documentNumber=${orderNo}&documentType=${docType}&documentStatus=${docStatus}`;
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            CustomerPortalDispatcher.dispatch({
                actionType: 'SET_ORDER_DRILL_DOWN',
                data: data
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    async quoteToOrder(quoteNo){
      return new Promise((resolve, reject) => {
        let params = {
            quoteNumber: quoteNo
        };
        let url = API.HOST + API.FETCH_QUOTE_TO_ORDER + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            },
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json()
        }).then((result) => {
          resolve(result);
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
      })
    }
    fetchMerchantBillingInfo() {
        let url = API.HOST + API.FETCH_DOC_MERCHANT_API;
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            CustomerPortalDispatcher.dispatch({
                actionType: 'FETCH_MERCHANT_BILLING',
                merchantBilling: data
            });
        }).catch((error) => {
            // displayGeneralMessage(error);
            console.error(`fetch error: ${error}`);
        });
    }
    fetchTransactionDetailAR(docno, transactiontype, docType) {
        let params = {
            transactiontype: transactiontype,
            docno: docno,
            docType: docType
        };
        let url = API.HOST + API.FETCH_DOC_DETAILS_AR_API + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (!data.error) {
                CustomerPortalDispatcher.dispatch({
                    actionType: 'FETCH_TRANSACTION_DETAIL',
                    transactionDetail: data
                });
            } else {
                displayGeneralMessage(data.error, '', 'error', false);
            }
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    fetchTransactionDetailOE(docno, type) {
        let params = {
            docno: docno,
            type: type
        };
        let url = API.HOST + API.FETCH_DOC_DETAILS_OE_API + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (!data.error) {
                CustomerPortalDispatcher.dispatch({
                    actionType: 'FETCH_TRANSACTION_DETAIL',
                    transactionDetail: data
                });
            } else {
                displayGeneralMessage(data.error, '', 'error', false);
            }
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    fetchTransactionDetailFW(docno, type) {
        let params = {
            invoiceno: docno,
        };
        let url = API.HOST + API.FETCH_DOC_DETAILS_FWLTC_API + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (!data.error) {
                CustomerPortalDispatcher.dispatch({
                    actionType: 'FETCH_TRANSACTION_DETAIL',
                    transactionDetail: data
                });
            } else {
                displayGeneralMessage(data.error, undefined, 'error', false, { autoRedirect: false });
            }
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    fetchTransactionDetailCM(docno, type, template, name){
      let customerNumber = CustomerPortalStore.getCustomerNumber();
        let params = {
            documentNumber: docno,
            template: template,
            documentType: type,
            customerNumber: customerNumber,
            name : name
        };
        let url = API.HOST + API.FETCH_DOC_DETAILS_CUSTOM_API + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (!data.error) {
                CustomerPortalDispatcher.dispatch({
                    actionType: 'FETCH_TRANSACTION_DETAIL',
                    transactionDetail: data
                });
            } else {
                displayGeneralMessage(data.error, undefined, 'error', false, { autoRedirect: false });
            }
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    fetchPayAccount(reset = false) {
        let url = API.HOST + API.FETCH_PAY_ACCOUNT_INFO;
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (data.error) {
                displayGeneralMessage(data.error,undefined,undefined,undefined,{autoRedirect:false});
            } else {
                CustomerPortalDispatcher.dispatch({
                    actionType: 'FETCH_PAY_ACCOUNT_INFO',
                    documents: data.documents,
                    useStoredCard: data.useStoredCard,
                    surchargeMessage: data.surchargeMessage,
                    makePaymentMessage: data.makePaymentMessage,
                    maxPaymentAmount: data.maxPaymentAmount,
                    paymentType : data.supportedPaymentTypes || [],
                    allowPayments: data.allowPayments,
                    allowOrderPayments: data.allowOrderPayments,
                    allowQuotePayments: data.allowQuotePayments,
                    allowUnallocatedPayments: data.allowUnallocatedPayments,
                    customerCurrency: data.customerCurrency,
                    reset: reset
                });
            }
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    async fetchPayAccountDetails(docNo,source){
      return new Promise((resolve, reject) => {
        let params = { docNo: docNo , source: source};
        let url = API.HOST + API.FETCH_PAY_ACCOUNT_DETAILS + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': authenticationService()
          }
        }).then((response) => {
          if (response.status == 500)
          throw new Error(response.status)
          return response.json()
        }).then((data) => {
          if (data.error) {
            throw new Error(data.error)
          }
          CustomerPortalDispatcher.dispatch({
            actionType: 'FETCH_PAY_ACCOUNT_DETAILS',
            data: data,
            docNo: docNo
          });
          resolve(data);
        }).catch((error) => {
          displayGeneralMessage();
          console.error(`fetch error: ${error}`);
        });
      });
    }
    updatePayAccountSelection(docNo) {
        CustomerPortalDispatcher.dispatch({
            actionType: 'LOCAL_UPDATE_PAY_ACCOUNT_SELECTION',
            docNo: docNo
        });
    }
    updatePayAccountTotal(docNo,input) {
        CustomerPortalDispatcher.dispatch({
            actionType: 'LOCAL_UPDATE_PAY_ACCOUNT_TOTAL',
            docNo: docNo,
            input: input
        });
    }
    selectAllPayment(selectAll) {
        CustomerPortalDispatcher.dispatch({
            actionType: 'LOCAL_SELECT_ALL_PAY',
            selectAll: selectAll
        });
    }
    fetchPaymentCards() {
        let url = API.HOST + API.PAYMENT_CARDS_API;
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            if (data.error) {
                throw new Error(data.error)
            }
            CustomerPortalDispatcher.dispatch({
                actionType: 'FETCH_PAYMENT_CARDS',
                paymentCards: data
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    setPaymentCardToDefault(id) {
        let params = {
            cardId: id
        };
        let url = API.HOST + API.PAYMENT_CARDS_API + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            },
            method: 'put',
            // body: JSON.stringify({ cardId:id }),
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            CustomerPortalDispatcher.dispatch({
                actionType: 'SET_PAYMENT_TO_DEFAULT',
                id: id
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    deletePaymentCard(id) {
        let params = {
            cardId: id
        };
        let url = API.HOST + API.PAYMENT_CARDS_API + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
            method: 'delete',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            CustomerPortalDispatcher.dispatch({
                actionType: 'DELETE_PAYMENT_CARD',
                id: id
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    fetchPrepayment(docType){
      let url = API.HOST + API.FETCH_PAY_ACCOUNT_INFO+"?docType="+docType;
      fetch(url, {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': authenticationService()
          }
      }).then((response) => {
          if (response.status == 500)
              throw new Error(response.status)
          return response.json()
      }).then((data) => {
          if (data.error) {
              displayGeneralMessage(data.error,undefined,undefined,undefined,{autoRedirect:false});
          } else {
              CustomerPortalDispatcher.dispatch({
                  actionType: 'FETCH_PREPAYMENT',
                  documents: data.documents,
                  surchargeMessage: data.surchargeMessage,
                  useStoredCard: data.useStoredCard,
                  makePaymentMessage: data.makePaymentMessage,
                  maxPaymentAmount: data.maxPaymentAmount,
                  paymentType : data.supportedPaymentTypes || [],
                  allowPayments: data.allowPayments,
                  allowOrderPayments: data.allowOrderPayments,
                  allowQuotePayments: data.allowQuotePayments,
                  allowUnallocatedPayments: data.allowUnallocatedPayments,
                  customerCurrency: data.customerCurrency,
              });
          }
      }).catch((error) => {
          displayGeneralMessage();
          console.error(`fetch error: ${error}`);
      });
    }
    resetPrepayment(){
      CustomerPortalDispatcher.dispatch({
          actionType: 'RESET_PREPAYMENT'
      });
    }
    updatePrepaymentSelection(docNo) {
        CustomerPortalDispatcher.dispatch({
            actionType: 'LOCAL_UPDATE_PREPAY',
            docNo: docNo
        });
    }
    updatePrepaymentTotal(docNo,input) {
        CustomerPortalDispatcher.dispatch({
            actionType: 'LOCAL_UPDATE_PREPAY_TOTAL',
            docNo: docNo,
            input: input
        });
    }
    selectAllPrepayment(selectAll,type) {
        CustomerPortalDispatcher.dispatch({
            actionType: 'LOCAL_SELECT_ALL_PREPAY',
            selectAll: selectAll,
            type: type
        });
    }
    insertUnallocatedPayment(transaction){
        CustomerPortalDispatcher.dispatch({
            actionType: 'INSERT_PREPAYMENT',
            transaction: transaction
        });
    }
    fetchContactFormInfo() {
        let url = API.HOST + API.FETCH_CONTACT_INFO_API;
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            CustomerPortalDispatcher.dispatch({
                actionType: 'SET_CUSTOMER_INFO',
                customerInfo: data
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
            CustomerPortalDispatcher.dispatch({
                actionType: 'SET_CUSTOMER_INFO',
                customerInfo: {}
            });
        });
    }
    sendContactMessage(msg,response='Your message has been sent to our team') {
        let url = API.HOST + API.POST_CONTACT_API;
        fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            },
            body: JSON.stringify(msg),
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            displayGeneralMessage(response, 'Sent!', 'success', true, { autoRedirect: true });
            CustomerPortalDispatcher.dispatch({
                actionType: 'RESET_CUSTOMER_INFO',
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    submitChangePasswordForm(input) {
        let url = API.HOST + API.POST_PASSWORD_API;
        fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            },
            body: JSON.stringify(input),
        }).then((response) => {
            if (response.status === 200) {
                displayGeneralMessage('Password Updated', 'Updated!', 'success', true, { autoRedirect: false });
                return response;
            } else {
                return response.json()
            }
        }).then((data) => {
            CustomerPortalDispatcher.dispatch({
                actionType: 'SET_ERROR',
                errors: data
            });
        }).catch((error) => {
            //displayGeneralMessage(error);
            console.error(`fetch error: ${error}`);
        });
    };
    fetchMyAccountInfo() {
        let url = API.HOST + API.MY_ACCOUNT_API;
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json()
        }).then((data) => {
            CustomerPortalDispatcher.dispatch({
                actionType: 'FETCH_MY_ACCOUNT_INFO',
                accountInfo: data
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    updateMyAccountInfo(inputs) {
        let params = {
            name: inputs.name,
            phoneNumber: inputs.phoneNumber,
            email: inputs.email
        };
        let url = API.HOST + API.MY_ACCOUNT_API;
        fetch(url, {
            method: 'put',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            },
            body: JSON.stringify(params),
        }).then((response) => {
            if (response.status == 500)
                throw new Error(response.status);
            return response.json();
        }).then((data) => {
            if (data.errorMessage) {
              data.error = { error: data.errorMessage }
            }
            if (!data.error) {
                displayToast('info', data.message || 'Updated');;
            }
            CustomerPortalDispatcher.dispatch({
                actionType: 'UPDATE_ACCOUNT_INFO',
                errors: { error: data.error },
                name: inputs.name
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    fetchPaymentInvoiceInfo(inputs,docType) {
        let params = {
            customerno: inputs.customerno.trim(),
            documentNo: inputs.invoiceno.trim(),
            docType: docType
        };
        if (docType == 'unapplied') params.zipCode = inputs.postalCode.trim();
        let url = API.HOST + API.FETCH_PAYMENT_INVOICE_INFO + '?';
        url += this.convertObjectToQueryString(params);
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status);
            return response.json()
        }).then((data) => {
            if (typeof data === "string") data = JSON.parse(data);
            CustomerPortalDispatcher.dispatch({
                actionType: 'FETCH_PAYMENT_INVOICE_INFO',
                invoiceInfo: data
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    fetchPaymentInvoiceReceipt(id) {
        // id is transaction id
        id = id.replace(/[^\x00-\x7F]/g, ""); // remove invalid characters
        let url = API.HOST + API.FETCH_TRANSACTION_INFO + '?transactionId=' + id;
        //console.log(url);
        fetch(url, {
            headers: {
                'Authorization': authenticationService()
            }
        }).then((response) => {
            if (response.status !== 200)
                throw new Error(response.status)
            return response.json();
        }).then((json) => {
            let data
            if (json.error) {
                data = {
                    transactionInfo:{
                        Status: "error",
                        errorCode: json.error,
                        formattedAmount:"",
                    }
                }
            } else {
                let documentNo = "";
                //capitalize TransactionDetails, EntityFramework object
                if (json.TransactionDetails[0]) {
                    documentNo = json.TransactionDetails[0].DocumentNo;
                }

                 data = {
                    receiptInfo: {
                        cardname: json.CardName,
                        cardno: json.CardNumber,
                        docno: documentNo,
                        docamount: json.Amount,
                        docreference: json.TransactionId,
                        doccode: json.AuthCode,
                    },
                    invoiceInfo: {
                        customerno: json.ArCustomerNo,
                        invoiceno: documentNo,
                        invoiceamount: json.Amount,
                    },
                    transactionInfo: json
                };
            }
            return data;
        }).then((data) => {
            CustomerPortalDispatcher.dispatch({
                actionType: 'FETCH_PAYMENT_INVOICE_RECEIPT',
                data: data
            });
        }).catch((error) => {
            displayGeneralMessage();
            console.error(`fetch error: ${error}`);
        });
    }
    async getCustomizationList(){
        return new Promise((resolve, reject) => {
             let url = API.HOST + API.GET_CUSTOMIZATION;
             fetch(url, {
                 headers: {
                     'Accept': 'application/json',
                     'Content-Type': 'application/json',
                     'Authorization': authenticationService()
                 }
             }).then((response) => {
                 if (response.status !== 200)
                     throw new Error(response.status)
                 return response.json()
             }).then((data) => {
                 resolve(data);
             }).catch((error) => {
                 displayGeneralMessage();
                 console.error(`fetch error: ${error}`);
             });
        });
    }
    fetchCustomization(name){
       let url = API.HOST + API.GET_CUSTOMIZATION + "?name="+name;
       fetch(url, {
           headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json',
               'Authorization': authenticationService()
           }
       }).then((response) => {
           if (response.status !== 200)
               throw new Error(response.status)
           return response.text()
       }).then((data) => {
           CustomerPortalDispatcher.dispatch({
               actionType: 'FETCH_CUSTOMIZATION',
               content: data,
               name: name
           });
       }).catch((error) => {
           displayGeneralMessage();
           console.error(`fetch error: ${error}`);
       });
    }
    async validateToken(token,id){
        return new Promise((resolve, reject) => {
            let url = API.HOST + API.VALIDATE_TOKEN +'?';
            url += this.convertObjectToQueryString({merchantId:id,token:token});
            fetch(url, {
                method: 'post',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
            }).then((response) => {
                if (response.status == 500)
                    throw new Error(response.status)
                return response.json();
            }).then((data) => {
                if (!data.error) {
                  resolve({success:true,user:data});
                } else {
                  resolve({success:false});
                }
            }).catch((error) => {
                console.error(`fetch error: ${error}`);
            });
        });
    }
    async getPayPalCredentials(){
        return new Promise((resolve, reject) => {
            let url = API.HOST + API.PAYPAL_CREDENTIALS;
            fetch(url, {
            }).then((response) => {
                if (response.status == 500)
                    throw new Error(response.status)
                return response.json();
            }).then((data) => {
              resolve(data);
            }).catch((error) => {
                console.error(`fetch error: ${error}`);
            });
        });
    }
    async createPayPalTransaction(amount, currency, orderId,customer,transaction) {
        return new Promise((resolve, reject) => {
            let data = transaction;
            data.Currency = currency;
            data.Amount = amount;
            data.Reference = orderId;
            data.ARCustomerNo = customer;
            let url = API.HOST + API.PAYPAL_CREATE_ORDER;
            fetch(url, {
                method: 'post',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            }).then((response) => {
                if (response.status == 500)
                    throw new Error(response.status)
                return response.json();
            }).then((data) => {
              resolve(data);
            }).catch((error) => {
                console.error(`fetch error: ${error}`);
            });
        });
    }
    async completePayPalTransaction(data){
          return new Promise((resolve, reject) => { 
              let url = API.HOST + API.PAYPAL_COMPELETE_ORDER;
              fetch(url, {
                method: 'post',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
              }).then((response) => {
                  if (response.status == 500)
                      throw new Error(response.status)
                  return response.json();
              }).then((data) => {
                console.log(data)
                resolve(data);
              }).catch((error) => {
                  console.error(`fetch error: ${error}`);
              });
          });
    }
    async setPayPalError(error){
            return new Promise((resolve, reject) => { 
                let url = API.HOST + API.PAYPAL_TRANSACTION_ERROR;
                fetch(url, {
                  method: 'post',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(error),
                }).then((response) => {
                    if (response.status == 500)
                        throw new Error(response.status)
                    return response.json();
                }).then((data) => {
                  console.log(data)
                  resolve(data);
                }).catch((error) => {
                    console.error(`fetch error: ${error}`);
                });
            });
        }
    async fetchPaymentType(currency) {
        return new Promise((resolve, reject) => {
          //let data = {
          //  useStoredCard: true,
          //  allowPayments: true,
          //  supportedPaymentTypes: [ {"name": "CC","surcharge": "0"}, {"name": "ACH","surcharge": "0"} ],
          //};
          //resolve(data);
            let url = API.HOST + API.GET_PAYMENT_SETTING+"?currency="+currency;
            fetch(url, {
                method: 'get',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': authenticationService()
                },
            }).then((response) => {
                if (response.status == 500)
                    throw new Error(response.status)
                return response.json()
            }).then((data) => {
                  CustomerPortalDispatcher.dispatch({
                     actionType: 'OVERALL_PAYMENT_SETTINGS',
                     data: data,
                     currency: currency,
                 });
                resolve(data);
            }).catch((error) => {
                console.error(`fetch error: ${error}`);
            });
        })
    };
}

export default new CustomerPortalAction();
